import {atom, selectorFamily, useSetRecoilState} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getFiltersSets} = api.filtersSets;

const getFiltersSetsRefresh = atom<number>({
  key: 'getFiltersSetsRefresh',
  default: 0,
});

const getFiltersSetsQuery = selectorFamily({
  key: 'getFiltersSets',
  get(params: Parameters<typeof getFiltersSets>[0]) {
    return async ({get}) => {
      get(getFiltersSetsRefresh);
      try {
        const {data} = await getFiltersSets(params, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useFiltersSetsRefresh = () => {
  const refreshFn = useSetRecoilState(getFiltersSetsRefresh);
  return () => refreshFn((prev) => prev + 1);
};

export const useGetFiltersSetsQuery = createQuery(getFiltersSetsQuery, getFiltersSetsRefresh);
export type GetFiltersSetsQuery = Parameters<typeof getFiltersSetsQuery>[0];
